import { Module } from '@nu-art/ts-common';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
class ModuleFE_Toasting_Class extends Module {
    models = [];
    modelTimeouts = {};
    dispatch_Models = new ThunderDispatcher('__onToastingModelsChange');
    toast = {
        open: (model) => {
            this.models.push(model);
            this.dispatch_Models.dispatchUI();
        },
        process: (id) => {
            const model = this.models.find(model => model.id === id);
            if (!model)
                return;
            this.modelTimeouts[model.id] = setTimeout(() => this.toast.close(model.id), model.duration);
        },
        close: (id) => {
            clearTimeout(this.modelTimeouts[id]);
            delete this.modelTimeouts[id];
            this.models = this.models.filter(model => model.id !== id);
            this.dispatch_Models.dispatchUI();
        }
    };
    getModels = () => [...this.models];
}
export const ModuleFE_Toasting = new ModuleFE_Toasting_Class();
//# sourceMappingURL=ModuleFE_Toasting.js.map